module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/dislikeLeaderBoard-243f9d50b25bfd53780dbf589ef6162a.svg";